import {useEffect, useState} from "react";
import {ProjectDto, ProjectService, ViewConstructorResultDto} from "../../api/psc";
import ProjectItem from "../projects/components/ProjectItem";
import {DialogContainer, DialogHeader, Spinner} from "../../components/exports";
import {Box} from "@mui/material";
import ProjectCompactItem from "../projects/components/ProjectCompactItem";

export default function ListConstructorVisitedProjectsDialog(props: {
    constructorViewInfo: ViewConstructorResultDto;
}) {

    const [projects, setProjects] = useState<ProjectDto[] | null>(null);

    useEffect(() => {
        ProjectService
            .listVisitedProjectsFromConstructor(props.constructorViewInfo.projectHashId, '1')
            .then(r => {
                setProjects(r);
            })
    }, []);

    if (projects === null) {
        return <Spinner/>
    }

    return <>
        {
            projects.map(m => {
                return <ProjectCompactItem key={m.hashId} project={m}/>
            })
        }
    </>

}
